import { createFileRoute } from "@tanstack/react-router";
import { Profile } from "@/lib/lazyPages";
import { SEO } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/profile")({
  head: () => seoHead(SEO.profile),
  component: Profile,
});
